import {
  type DeviceOption,
  DeviceOptionType,
  RepairTypeId,
} from '@service-initiation/shared-clients-tech-care-services';

import { getDeviceTypeOptions } from './getDeviceTypeOptions';
import { type DeviceDetails } from './types/DeviceDetails';

export const getDeviceColorOptions = async (
  device: DeviceDetails
): Promise<DeviceOption[]> => {
  const repairId = device?.repairs?.find(
    (r) => r.repairType.id === RepairTypeId.CrackedScreen
  );
  if (repairId) {
    const deviceOptions = await getDeviceTypeOptions({
      deviceRepairId: repairId.id,
    });
    const option = deviceOptions?.option_types.find(
      (option) => option.id === DeviceOptionType.Color
    );
    return option?.options ? option?.options : [];
  }

  return [];
};
